import moment from 'moment';
import http from '~/http/index';
import newhttp from '~/http/new';

export default ({
  state: {
    data: [],
    filters: {},
    sort: {
      sort: 'defaultSort',
      sortDesc: false,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const { id } = rootState.user.user;

      const filterEmptyValues = (obj) => {
        const filtered = {};
        Object.keys(obj).forEach((key) => {
          if (obj[key] !== '') {
            filtered[key] = obj[key];
          }
        });
        return filtered;
      };

      const filteredFilters = filterEmptyValues(filters);

      const baseData = {
        userIdList: [id],
        ...filteredFilters,
        ...sort,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
        dateFrom: filters.dateFrom ? moment.utc(filters.dateFrom).unix() : undefined,
        dateTo: filters.dateTo ? moment.utc(filters.dateTo).set({ hour: 23, minute: 59, second: 59 }).unix() : undefined,
      };

      return {
        ...baseData,
      };
    },

    appType() {
      return process.env.VUE_APP_EXCLUDE_FEATURE?.split(' ').includes('transactions-old');
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit }, data) {
      const url = getters.appType ? 'v1/user/api-keys' : 'User/GetApiKeys';
      const protocol = getters.appType ? newhttp : http;
      const method = 'get';

      const requestData = {
        params: {
          ...getters.requestData,
          ...data,
        },
      };

      const response = await protocol[method](url, requestData);
      const { apiKeyList, pages } = response.data;
      commit('SET_DATA', apiKeyList);
      if (pages) {
        commit('SET_PAGES', pages);
      }
    },

    async updateApiKey({ getters }, data) {
      const url = getters.appType ? 'v1/user/api-keys' : 'v2/User/UpdateApiKey';
      const protocol = getters.appType ? newhttp : http;
      const method = getters.appType ? 'put' : 'post';

      const requestData = { ...getters.requestData, ...data };

      const response = await protocol[method](url, requestData);
      return response.data;
    },
  },

  namespaced: true,
});
